export const mapearDatosAmoniaco = (recepciones) => {
    const nuevasRecepciones = recepciones.map(item => {
        // Convertir fecha de "2025-11-12T03:52:19" a "2025-11-12 03:52:19"
        const fecha = item.fecha ? item.fecha.replace("T", " ") : null;

        return {
            bonificacion: item.bonificacion || 0,
            bonificacion_quetzales: item.bonificacion_quetzales || 0,
            bono_por_kilogramo: item.bono_por_kilogramo || 0,
            fecha: fecha,
            guardar: (item.bonificacion || 0) > 0,
            id_finca: item.finca_id,
            id_recepcion: item.id_recepcion,
            kilos_secos: item.kilos_secos || 0,
            nh3: item.nh3,
            valor_limite_nh3: item.valor_limite_nh3 || 0,
        };
    });

    // Retornar una copia profunda para evitar referencias
    return JSON.parse(JSON.stringify(nuevasRecepciones));
}


export const mapearDatosFletes = (recepciones) => {
    const nuevasRecepciones =  recepciones.map(item => {
        const fecha = item.fecha ? item.fecha.replace("T", " ") : null;

        return {
            bonif_fletes_bono_por_kg: item.bonif_fletes_bono_por_kg || 0,
            bonif_fletes_min_kg: item.bonif_fletes_min_kg || 0,
            bonificacion: item.bonificacion || 0,
            bonificacion_quetzales: item.bonificacion_quetzales || 0,
            fecha: fecha,
            guardar: (item.bonificacion || 0) > 0,
            id_finca: item.finca_id,
            id_recepcion: item.id_recepcion,
            kilos_secos: item.kilos_secos || 0,
            peso_neto: item.peso_neto || 0,
        };
    });

    // Retornar una copia profunda para evitar referencias
    return JSON.parse(JSON.stringify(nuevasRecepciones));
};
